const CheckNotNull = Symbol('CheckNotNull');

class PublicUser {
    id: string = '';
    salutation: string = '';
    fullname: string = '';
    email: string = '';
    phone: string = '';
    designation: string = '';
    rpmNo: string = '';
    constructor(
        id: string,
        salutation: string,
        fullname: string,
        email: string,
        phone: string,
        designation: string,
        rpmNo: string
    ) {
        this.id = this[CheckNotNull](id) ? id : '';
        this.salutation = this[CheckNotNull](salutation) ? salutation : '';
        this.fullname = this[CheckNotNull](fullname) ? fullname : '';
        this.email = this[CheckNotNull](email) ? email : '';
        this.phone = this[CheckNotNull](phone) ? phone : '';
        this.designation = this[CheckNotNull](designation) ? designation : '';
        this.rpmNo = this[CheckNotNull](rpmNo) ? rpmNo : '';
    }
    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    } 
}
export default PublicUser;